function handleCollapseButton(event, ...selectors) {
  const button = event.target.closest("button")

  button.classList.toggle("btn-collapse--active")

  selectors.forEach((selector) => {
    document.querySelectorAll(selector).forEach((element) => {
      if (element.classList.contains("collapse--active")) {
        element.setAttribute("aria-hidden", "true")
      } else {
        element.setAttribute("aria-hidden", "false")
      }

      element.classList.toggle("collapse--active")
    })
  })
}
